export const TextAreaDefaultRowsCount = 2;
export const separator = '.';
export const FAST_ADD_COMMON_ITEM = 'COMMON';
export const ADD_NEW_PREFIX = 'add-new';

export enum FieldActionType {
  ASSIGN_TO_MYSELF = 'ASSIGN_TO_MYSELF',
}
